import { UserManagementModal } from "../UserManagementModal";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";
import { useCallback } from "react";
import {
  useLtiToolCreationState,
  LtiToolCreationState,
  getError,
  initLtiToolCreationState,
} from "../state/useLtiToolCreationState";
import axios from "../../../../services/axios";
import { TechnicalIssuesMessage } from "../../utils/Toast";

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function AddLtiTool(props: any) {
  const [state, dispatch] = useLtiToolCreationState(props);
  const classes = useStyle();
  const updateForm = useCallback(
    (update: Partial<LtiToolCreationState["form"]>) =>
      dispatch({ type: "updateForm", update }),
    [dispatch]
  );
  const submit = async () => {
    const { form } = state;
    let data = {
      toolJwkMethod: form.toolJwkMethod,
      toolLaunchUrl: form.toolLaunchUrl,
      toolOidcEndpoint: form.toolOidcEndpoint,
      toolPublicJwk: form.toolPublicJwk,
      toolRedirectUris: form.toolRedirectUris
        .replace(/\s/g, "")
        .split(",")
        .filter((uri: string) => uri !== ""),
      toolName: form.toolName,
      toolDescription: form.toolDescription,
    };

    try {
      await axios.post("/lti/1p3/register-tool", data);
      props.onSubmit({
        severity: "success",
        message: "LTI Tool added successfully",
      });
      dispatch({
        type: "replaceState",
        state: initLtiToolCreationState(props.currentUser, state.data),
      });
    } catch (e: any) {
      props.onSubmit({
        severity: "error",
        message: TechnicalIssuesMessage,
      });
      throw e;
    }
  };
  return (
    <UserManagementModal
      title={"Add New Lti Provider Tool"}
      open={props.open}
      onClose={props.onClose}
      onSave={submit}
      errorText={getError(state)}>
      <Typography color="textSecondary" sx={{ marginBottom: "2rem" }}>
        Configure new LTI Provider Tool
      </Typography>
      <Grid container spacing={6}>
        <Grid item xs={6}>
          <TextField
            className={classes.inputText}
            value={state.form.toolName}
            onChange={(e) => {
              updateForm({ toolName: e.target.value });
            }}
            label="Tool name"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            className={classes.inputText}
            value={state.form.toolDescription}
            onChange={(e) => {
              updateForm({ toolDescription: e.target.value });
            }}
            label="Tool Description"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={6} mt={2}>
        <Grid item xs={6}>
          <TextField
            className={classes.inputText}
            value={state.form.toolOidcEndpoint}
            onChange={(e) => {
              updateForm({ toolOidcEndpoint: e.target.value });
            }}
            label="OpenID Connect Initiation Url"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            className={classes.inputText}
            value={state.form.toolLaunchUrl}
            onChange={(e) => {
              updateForm({ toolLaunchUrl: e.target.value });
            }}
            label="Target Link URI"
            fullWidth
            required
          />
        </Grid>
      </Grid>
      <Grid mt={2} item xs={6}>
        <FormControl sx={{ width: "100%" }}>
          <InputLabel id="demo-simple-select-autowidth-label">JWK Method</InputLabel>
          <Select
            labelId="demo-simple-select-autowidth-label"
            id="demo-simple-select-autowidth"
            value={state.form.toolJwkMethod}
            onChange={(e) => {
              updateForm({ toolJwkMethod: e.target.value });
            }}
            autoWidth
            label="JWK Method"
            required={true}>
            <MenuItem value={"public_jwk"}>Public JWK</MenuItem>
            <MenuItem value={"public_jwk_url"}>Public JWK Url</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid mt={2} item xs={6}>
        <TextField
          className={classes.inputText}
          value={state.form.toolPublicJwk}
          onChange={(e) => {
            updateForm({ toolPublicJwk: e.target.value });
          }}
          label="Public JWK"
          fullWidth
          required
          rows={state.form.toolJwkMethod === "public_jwk" ? 4 : 1}
          multiline={true}
        />
      </Grid>
      <Grid mt={4} item xs={6}>
        <TextField
          className={classes.inputText}
          value={state.form.toolRedirectUris}
          onChange={(e) => {
            updateForm({ toolRedirectUris: e.target.value });
          }}
          label="Redirect URIs"
          fullWidth
          required
          rows={4}
          multiline={true}
          helperText={"Enter URI comma separated"}
        />
      </Grid>
    </UserManagementModal>
  );
}
